import createAPIRequestId from "../helpers/createAPIRequestId";
import store from "../store/index";
//-------------------------------
// edit character characteristic
//-------------------------------
export default async function useEditCharacterCharacteristic(this_char) {
  console.log("-------------------------------------");
  console.log("IN useEditCharacterCharacteristic....");

  return new Promise((resolve) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //--------------------
    // set api call parms
    //--------------------
    let parm_id = "";
    let parm_partialInd = false;

    if (this_char.id != "") {
      parm_id = this_char.id;
      parm_partialInd = true;
    }

    let request_parms = {
      endpoint: "api/v1/character-characteristics/",
      partialInd: parm_partialInd,
      id: parm_id,
    };
    //--------------------------
    // create api request by id
    //--------------------------
    let request = createAPIRequestId(request_parms);
    //---------------
    // set api parms
    //---------------
    let api_parms = {
      api_request: request,
      payload: this_char.payload,
    };
    //----------
    // call api
    //----------
    this_store
      .dispatch("characters/editCharacterCharacteristic", api_parms)
      .then((response) => {
        resolve(response);
      });
  });
}
